<template>
	<article>
		<section class="xbed-sub-title">
			<span>所有卡券</span>
		</section>
		<section class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>营销管理</BreadcrumbItem>
				<BreadcrumbItem>所有卡券</BreadcrumbItem>
			</Breadcrumb>
		</section>
		<br>
		<Form @submit.native.prevent="preventSubmit" inline>
			<FormItem label="卡券ID:" prop="cardId" :label-width="84">
				<Input type="text" v-model="codeStoreList .cardId"></Input>
			</FormItem>
			<FormItem label="标题/简介:" prop="titleDescription" :label-width="84">
				<Input type="text" v-model="codeStoreList.titleDescription"></Input>
			</FormItem>
			<FormItem label="卡券类型:" :label-width="84" prop="couponCardType">
				<Select v-model="codeStoreList.couponCardType" filterable style='width:150px;'>
					<Option :value='-1'>全部</Option>
					<Option :value='1'>兑换券</Option>
					<Option :value='2'>代金券</Option>
					<Option :value='3'>折扣券</Option>
				</Select>
			</FormItem>
			<FormItem label="优惠成本:" :label-width="84" prop="bearParty">
				<Select v-model="codeStoreList.bearParty" filterable style='width:150px;'>
					<Option :value='-1'>全部</Option>
					<Option :value='1'>Xbed承担</Option>
					<Option :value='2'>业主承担</Option>
				</Select>
			</FormItem>
			<FormItem label="是否参加:" :label-width="84" prop="showBlueClient">
				<Select v-model="codeStoreList.showBlueClient" filterable style='width:150px;'>
					<Option :value='-1'>全部</Option>
					<Option :value='0'>必须参加</Option>
					<Option :value='1'>业主可选不参加</Option>
				</Select>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="queryKesBtn">查询</Button>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="initModal('POST')">新增卡券</Button>
			</FormItem>
			<Table stripe :loading="listLoading" ref="codeStoreTable" :columns="column" :data="displayData" class="hidden-header-selection" ></Table>
			<div style="margin: 10px;overflow: hidden">
				<Page show-sizer placement="top" :total="listCount" :current="codeStoreList.page" :page-size="codeStoreList.size"	@on-page-size-change="changePageSize" @on-change="changePage"></Page>
			</div>
		</Form>
    <!-- 删除 -->
		<Modal v-model="modalData.delete" :width="400" title="消息提醒" @on-ok='deleteData(modalData.currentRow.cardId)' ok-text='删除' @on-cancel='()=>{modalData.delete = false}'>
			<p style="font-size:14px;">确定删除 <span style="color:red;">{{modalData.currentRow.title}}</span> 吗？</p>
			<p style="font-size:14px;">一经确定将无法修改</p>
		</Modal>
    <!-- 编辑修改 -->
		<Modal v-model="modalData.display" ref="modalDataModal" :loading="true" :title="modalData.type == 'POST'?'新增卡券':'修改卡券信息'" @on-ok="()=>modalData.type == 'POST'?adddate():update()" ok-text='提交内容' @on-cancel='closeModal(false)'>
			<Form @submit.native.prevent="preventSubmit" inline :rules="modalDataRules" ref="modalDataModalForm" :label-width='100'>
				<FormItem label="微信卡券ID" prop="cardId" v-show="modalData.data.couponCardSource === 'wechat'">
					<Input :maxlength="500" v-model="modalData.data.cardId" style="width:350px;"></Input>
				</FormItem>
				<FormItem label="卡券来源" prop="couponCardSource">
					<Select v-model="modalData.data.couponCardSource" style="width:350px;">
						<Option v-for="item in cardSource" :key="item.value" :value="item.value">{{item.label}}</Option>
					</Select>
				</FormItem>
				<FormItem label="卡券类型" prop="couponCardType">
					<Select v-model="modalData.data.couponCardType" style="width:350px;">
						<Option :value="1">兑换券</Option>
						<Option :value="2">代金券</Option>
						<Option :value="3">折扣券</Option>
					</Select>
				</FormItem>
				<FormItem label="卡券标题" prop="title">
					<Input v-model="modalData.data.title" type="textarea" :autosize="{minRows: 1,maxRows: 2}" :maxlength='200' style="width:350px;"></Input>
				</FormItem>
				<FormItem label="优惠成本" prop="bearParty">
					<RadioGroup v-model="modalData.data.bearParty">
						<Radio :label="1">
							<span>Xbed承担</span>
						</Radio>
						<Radio :label="2">
							<span>业主承担</span>
						</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="是否强制参加" prop="showBlueClient">
					<RadioGroup v-model="modalData.data.showBlueClient">
						<Radio :label="1">
							<span>业主可选不参加</span>
						</Radio>
						<Radio :label="0">
							<span>必须参加</span>
						</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="兑换房晚(整数/晚)" v-if="modalData.data.couponCardType == 1" prop="exchangeNumber">
					<Input type="text" style="width:350px;" :maxlength="11" v-model="modalData.data.exchangeNumber"></Input>
				</FormItem>
				<FormItem label="减免金额" v-if="modalData.data.couponCardType == 2" prop="reduceCost">
					<Input type="text" style="width:350px;" :maxlength="11" v-model="modalData.data.reduceCost"></Input>
				</FormItem>
				<FormItem label="折扣额度(如：70代表7折)" v-if="modalData.data.couponCardType == 3" prop="discount">
					<Input type="text" style="width:350px;" :maxlength="11" v-model="modalData.data.discount"></Input>
				</FormItem>
				<FormItem label="抵扣条件(满x元可用)" prop="leastCost">
					<Input type="text" style="width:350px;" :maxlength="11" v-model="modalData.data.leastCost"></Input>
				</FormItem>
				<FormItem label="有效期" prop="createDate">
					<DatePicker type="daterange" v-model="modalData.data.createDate"	@on-change="dateRange => {changeDate(dateRange, 'modalData','data','createDate')}" style="width:350px;" :clearable="false" format="yyyy-MM-dd"></DatePicker>
				</FormItem>
				<FormItem label=" 简介" prop="description">
					<Input type="textarea" :autosize="{minRows: 2,maxRows: 5}" :maxlength="2000" v-model="modalData.data.description" style="width:350px;"></Input>
				</FormItem>
				<FormItem label="优惠总限额" prop="maxCost">
					<Input v-model="modalData.data.maxCost" type="text" :maxlength="11" style="width:350px;"></Input>
				</FormItem>
				<FormItem label="参与的房间" prop="roomCondition">
					<Input type="text" :maxlength="2000" v-model="modalData.data.roomCondition" style="width:350px;"></Input>
				</FormItem>
				<FormItem label="参与的用户" v-if="modalData.data.couponCardSource === 'xbed'" prop="userCondition">
					<Input type="text" :maxlength="2000" v-model="modalData.data.userCondition" style="width:350px;"></Input>
				</FormItem>
				<FormItem label="其他条件">
					<Checkbox v-model="modalData.data.weekend">周末不可用</Checkbox>
					<Checkbox v-model="modalData.data.holidays">节假日不可用</Checkbox>
				</FormItem>
				<FormItem label="库存" prop="totalQuantity">
					<Input type="text" v-model="modalData.data.totalQuantity" :maxlength="11" style="width:350px;"></Input>
				</FormItem>
				<FormItem label="备注" prop="remark">
					<Input type="textarea" :autosize="{minRows: 2,maxRows: 5}" :maxlength="2000" v-model="modalData.data.remark" style="width:350px;"></Input>
				</FormItem>
			</Form>
		</Modal>
	</article>
</template>

<script>
	import Moment from "moment";
	import Utils from "../../utils";
	import API from "../../api";
	export default {
		created() {
			this.token = Utils.findFromLocalStorage("vue-token");
			this.username = Utils.findFromLocalStorage("vue-username");
			this.env = Utils.findFromLocalStorage("env", "dev");
		},
		data() {
			const validateGoodsList = {
				title: ( rule, value, callback ) => {
					if (!this.modalData.data.title) {
						callback( new Error( '卡券标题长度不能为空并且小于200个字节' ) )
					} else {
						callback();
					}
				},
				description: ( rule, value, callback ) => {
					if (!this.modalData.data.description) {
						callback( new Error( '简介不能为空' ) )
					} else {
						callback();
					}
				},
				exchangeNumber: ( rule, value, callback ) => {
					const numRegExp = /^[1-9]\d*$/;
					if (this.modalData.data.couponCardType == 1 && !numRegExp.test(this.modalData.data.exchangeNumber)) {
						callback( new Error( '格式不正确' ) )
					} else {
						callback();
					}
				},
				reduceCost: ( rule, value, callback ) => {
					const numRegExp = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/
					if (this.modalData.data.couponCardType == 2 && !numRegExp.test(this.modalData.data.reduceCost)) {
						callback( new Error( '格式不正确' ) )
					} else {
						callback();
					}
				},
				discount: ( rule, value, callback ) => {
					const numRegExp = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/
					if (this.modalData.data.couponCardType == 3 && !numRegExp.test(this.modalData.data.discount)) {
						callback( new Error( '格式不正确' ) )
					} else {
						callback();
					}
				},
				leastCost: ( rule, value, callback ) => {
					const numRegExp = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/
					if (!numRegExp.test(this.modalData.data.leastCost)) {
						callback( new Error( '抵扣条件格式不正确' ) )
					} else {
						callback();
					}
				},
				maxCost: ( rule, value, callback ) => {
					const numRegExp = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/
					if (!numRegExp.test(this.modalData.data.maxCost)) {
						callback( new Error( '优惠总限额格式不正确' ) )
					} else {
						callback();
					}
				},
				totalQuantity: ( rule, value, callback ) => {
					const numRegExp = /^[1-9]\d*$/;
					if (!numRegExp.test(this.modalData.data.totalQuantity)) {
						callback( new Error( '库存格式不正确' ) )
					} else {
						callback();
					}
				},
				remark: ( rule, value, callback ) => {
					if ( !this.modalData.data.remark) {
						callback( new Error( '备注不能为空' ) )
					} else {
						callback();
					}
				}
			}
			return {
				cardSource:[{value:'wechat',label:"微信"},{value:'xbed',label:"自有"}],
				exportBtn: false,
				codeStoreForm: {
					grant: 0,
					receive: 0,
					issueDate: [],
					keyword: ""
				},
				column: [
					{
						title: "卡券ID",
						key: "cardId", //OK
						align: "center",
						width: 220
					},
					{
						title: "卡券来源",
						key: "couponCardSource", //OK
						align: "center",
						width: 100
					},
					{
						title: "卡券类型",
						key: "couponCardType", //1兑换券，2代金券，3折扣券
						align: "center",
						width: 100,
						render: (h, p) => {
							return h(
								"span",
								{
									style: {
										color: "#fff",
										padding: "5px",
										backgroundColor: [
											"",
											"#2d8cf0",
											"#ff9900",
											"#19be6b"
										][p.row.couponCardType]
									}
								},
								["", "兑换券", "代金券", "折扣券"][
									p.row.couponCardType
								]
							);
						}
					},
					{
						title: "优惠成本",
						key: "bearParty", //1Xbed承担，2业主承担
						align: "center",
						width: 100,
						render: (h, p) =>
							h(
								"span",
								{},
								["", "Xbed承担", "业主承担"][p.row.bearParty]
							)
					},
					{
						title: "是否参加",
						key: "showBlueClient", //[\'必须参加\',\'业主可选不参加\'][obj.showBlueClient]
						align: "center",
						width: 150,
						render: (h, p) =>
							h(
								"span",
								{},
								["必须参加", "业主可选不参加"][p.row.showBlueClient]
							)
					},
					{
						title: "优惠额度",
						align: "center",
						width: 100,
						render: (h, p) => {
							let value = "";
							switch (p.row.couponCardType) {
								case 1:
									value = p.row.exchangeNumber + " 晚";
									break;
								case 2:
									value = p.row.reduceCost + " 元";
									break;
								case 3:
									value = p.row.discount / 10 + " 折";
									break;
							}
							return h("span", {}, value);
						}
					},
					{
						title: "抵扣条件",
						key: "leastCost", //满X元使用
						align: "center",
						width: 150,
						render: (h, params) =>
							{
								return h(
									"span",
									{},
									`满${params.row.leastCost}元使用`
								)
							}
					},
					{
						title: "优惠总限额",
						key: "maxCost", //OK
						align: "center",
						width: 150,
						render: (h, params) =>{
							return h(
								"span",
								{},
								`${params.row.maxCost} 元`
							)
						}
					},
					{
						title: "卡券标题",
						key: "title",
						align: "center",
						width: 200
					},
					{
						title: "简介",
						key: "description", //OK
						align: "center",
						width: 220
					},
					{
						title: "可预订起止时间",
						key: "beginTimestamp",
						align: "center",
						width: 200,
						render: (h, p) =>
							h("span", {}, [
								Moment(p.row.beginTimestamp).format(
									"YYYY-MM-DD HH:mm:ss"
								),
								h(
									"p",
									{
										style: {
											textAlign: "center"
										}
									},
									"~"
								),
								Moment(p.row.endTimestamp).format(
									"YYYY-MM-DD HH:mm:ss"
								)
							])
					},
					{
						title: "参与房间",
						key: "roomCondition", //OK
						align: "center",
						width: 150
					},
					{
						title: "参与用户",
						key: "userCondition", //OK
						align: "center",
						width: 150
					},
					{
						title: "限定条件",
						align: "center",
						width: 150,
						render: (h, p) => {
							let weekend = /weekend/.exec(p.row.otherUse);
							let holidays = /holidays/.exec(p.row.otherUse);
							let weekColor = weekend ? "red"	: "green"
							let holidaysColor = holidays	? "red"	: "green"
							return h("div", [
								h("Tag",{
										props: {
											color: weekColor
										}
									},
									`周末${weekend ? "不" : ""}可用`
								),
								h(
									"Tag",
									{
										props: {
											color: holidaysColor
										}
									},
									`节假日${holidays ? "不" : ""}可用`
								)
							]);
						}
					},
					{
						title: "库存",
						key: "totalQuantity", //OK
						align: "center",
						width: 100
					},
					{
						title: "库存最后更新时间",
						key: "updateTimestamp", //OK
						align: "center",
						width: 200,
						render: (h, p) =>
							h(
								"span",
								{},
								Moment(p.row.updateTimestamp).format(
									"YYYY-MM-DD HH:mm:ss"
								)
							)
					},
					{
						title: "备注",
						key: "remark", //OK
						align: "center",
						width: 200
					},
					{
						title: "操作", //OK
						align: "center",
						width: 150,
						render: (h, params) =>
							h("div", {}, [
								h(
									"Button",
									{
										props: {
											type: "primary",
											size: "small"
										},
										style: {
											marginRight: "5px"
										},
										on: {
											click: () => {
												this.initModal("PUT", params.row);
											}
										}
									},
									"修改"
								),
								h(
									"Button",
									{
										props: {
											type: "error",
											size: "small"
										},
										on: {
											click: () => {
												if ( !Utils.hasPermission( 'couponCard_del' ) ) {
													this.$Notice.error( {
														title: "无权限操作"
													} );
													return
												}
												this.modalData.currentRow = params.row
												this.modalData.delete = true;
											}
										}
									},
									"删除"
								)
							])
					}
				],
				modalDataRules:{
          title: [
						{validator: validateGoodsList.title, required: true, trigger: 'blur'}
					],
					description: [
						{validator: validateGoodsList.description, required: true, trigger: 'blur'}
					],
					exchangeNumber: [
						{validator: validateGoodsList.exchangeNumber, required: true, trigger: 'blur'}
					],
					reduceCost: [
						{validator: validateGoodsList.reduceCost, required: true, trigger: 'blur'}
					],
					discount: [
						{validator: validateGoodsList.discount, required: true, trigger: 'blur'}
					],
					leastCost: [
						{validator: validateGoodsList.leastCost, required: true, trigger: 'blur'}
					],
					maxCost: [
						{validator: validateGoodsList.maxCost, required: true, trigger: 'blur'}
					],
					totalQuantity: [
						{validator: validateGoodsList.totalQuantity, required: true, trigger: 'blur'}
					],
					remark: [
						{validator: validateGoodsList.remark, required: true, trigger: 'blur'}
					]
				},
				modalData: {
					display: false,
					apply: false,
					loading: false,
					type: "",
					data: {
						cardId: "",
						couponCardSource: 'xbed', //["微信","xbed"]
						couponCardType: 1,
						title: "",
						bearParty: 1, //["","Xbed承担","业主承担"]
						showBlueClient: 0, //['必须参加','业主可选不参加']
						reduceCost: "", //initPrice
						leastCost: "",
						createDate:[],
						description: "",
						maxCost: "", //initPrice
						roomCondition: "",
						userCondition: "",
						weekend: false,
						holidays: false,
						totalQuantity: "", //initPrice
						remark: "",
						discount: "",
						exchangeNumber: ''
					},
					delete:false,
					currentRow:{},
					initData: {
						// id: null,
						cardId: "",
						couponCardSource: 'xbed', //["微信","xbed"]
						couponCardType: 1,
						title: "",
						bearParty: 1, //["","Xbed承担","业主承担"]
						showBlueClient: 0, //['必须参加','业主可选不参加']
						reduceCost: "", //initPrice
						leastCost: "",
						beginTime: "",
						endTime: "",
						description: "",
						maxCost: "", //initPrice
						roomCondition: "",
						userCondition: "",
						weekend: false,
						holidays: false,
						totalQuantity: "", //initPrice
						remark: "",
						discount: "",
						exchangeNumber: '',
						preferential: "",
						updateTime: ""
					}
				},
				codeStoreList: {
					url:'/api/couponCard',
					cardId:'',
					titleDescription:'',
					couponCardType:-1,
					bearParty:-1,
					showBlueClient:-1,
					page: 1, // 第几页
					size: 10, // 每页数量
				},
				listLoading: false,
				listCount:0,
				filterCodeStoreList: [],
				displayData: [],
				selectedAllState: false,
				selectedCodes: new Set()
			};
		},
		mounted() {
			this.$Notice.config({
				top: 200
			});
			this.selectPageData();
		},
		filters: {
			initPrice( val = 0 ) {
				return ( val / 100 ).toFixed( 0 )
			}
		},
		methods: {
			async selectPageData() {
				if ( !Utils.hasPermission( 'couponCard_list' ) ) {
					this.$Notice.error( {
						title: "无权限操作"
					} );
					return
				}
				this.listLoading = true
				let params = {
					url:this.codeStoreList.url,
					cardId:this.codeStoreList.cardId,
					titleDescription:this.codeStoreList.titleDescription,
					couponCardType:this.codeStoreList.couponCardType,
					bearParty:this.codeStoreList.bearParty,
					showBlueClient:this.codeStoreList.showBlueClient,
					page:this.codeStoreList.page - 1,
					size:this.codeStoreList.size,
				}
				let resp = ( await API.omsAPI[this.env].marketing.CouponCard("GET",params,this.token)).data
				this.listLoading = false;
				if ( resp.retCode ) {
					this.$Notice.error( {
						title: "查询失败",
						desc: resp.msg
					} );
					return
				}
				this.displayData = resp.content || []
				this.listCount = resp.total
				if (this.displayData.length != 0) {
					this.displayData.map(item=>{
						if(item.leastCost) item.leastCost = (item.leastCost / 100).toFixed(2) 
						if(item.maxCost) item.maxCost = (item.maxCost / 100).toFixed(2) 
						if(item.reduceCost) item.reduceCost = (item.reduceCost / 100).toFixed(2) 
						return item
					})
				}
			},
			changePage(pageIndex) {
				this.codeStoreList.page = pageIndex;
				this.selectPageData();
			},
			changePageSize(pageSize) {
				this.codeStoreList.page = 1;
				this.codeStoreList.size = pageSize;
				this.selectPageData();
			},
			queryKesBtn(){
				this.codeStoreList.page = 1;
        this.selectPageData();
			},
			initModal(type, row) {
				if ( !Utils.hasPermission( 'couponCard_edit' ) ) {
					this.$Notice.error( {
						title: "无权限操作"
					} );
					return
				}
				if (type == "PUT") {
					//编辑
					let obj = {}
					obj.weekend = !!/weekend/.exec(row.otherUse);
					obj.holidays = !!/holidays/.exec(row.otherUse);
					obj.createDate = [Moment( row.beginTimestamp ).format( 'YYYY-MM-DD 00:00:00' ),Moment( row.endTimestamp ).format( 'YYYY-MM-DD 23:59:59' )]
					this.modalData.data = Object.assign({}, obj,row);
				} else {
					//新增
					this.modalData.data = Object.assign(
						{createDate:[Moment().format('YYYY-MM-DD 00:00:00'),  Moment().subtract(-7, 'days').format('YYYY-MM-DD 23:59:59')]},
						this.modalData.initData
					);
				}
				this.modalData.type = type;
				this.modalData.display = true;
			},
			async update(){
				let validResult = false;
				this.$refs.modalDataModalForm.validate( valid => {
					validResult = valid
				} );
				if ( !validResult ) {
					this.$refs.modalDataModal.buttonLoading = false;
					return;
				}
				this.modalData.display = false
				let params = {url:'/api/couponCard'}
						params['id']               = this.modalData.data['id'];
						params['beginTimestamp']   = Moment( this.modalData.data.createDate[0] )?Moment( this.modalData.data.createDate[0] ).format( 'YYYY-MM-DD 00:00:00' ):"";
						params['endTimestamp']     = Moment( this.modalData.data.createDate[1] )?Moment( this.modalData.data.createDate[1] ).format( 'YYYY-MM-DD 23:59:59' ):"";
						params['cardId']           = this.modalData.data['cardId'];
						params['couponCardSource'] = this.modalData.data['couponCardSource'];
						params['couponCardType']   = this.modalData.data['couponCardType'];
						params['description']      = this.modalData.data['description'];
						params['leastCost']        = this.modalData.data['leastCost'] * 100;
						params['totalQuantity']    = this.modalData.data['totalQuantity'];
						params['title']            = this.modalData.data['title'];
						params['maxCost']          = this.modalData.data['maxCost'] * 100;
						params['type']             = 'DATE_TYPE_FIX_TIME_RANGE';
						params['remark']           = this.modalData.data['remark'];
						params['roomCondition']	  = this.modalData.data['roomCondition'] === null ? '' : this.modalData.data['roomCondition'];
						params['userCondition']	  = this.modalData.data['userCondition'] === null ? '':this.modalData.data['userCondition'];
						params['bearParty']	  = this.modalData.data['bearParty'];
						params['showBlueClient']	  = this.modalData.data['showBlueClient'];
						params['otherUse'] = [this.modalData.data['weekend']?"weekend":"",this.modalData.data['holidays']?"holidays":""].join(',')
	
				switch (this.modalData.data['couponCardType']) {
				case 1:
					params['exchangeNumber'] = this.modalData.data['exchangeNumber'];
					params['exchangeType']   = 'room';
					break;
				case 2:
					params['reduceCost'] = this.modalData.data['reduceCost'] * 100;
					break;
				case 3:
					params['discount'] = this.modalData.data['discount'];
					break;
				}
				let resp = ( await API.omsAPI[this.env].marketing.CouponCard("PUT", params,this.token,)).data;
				if ( resp.retCode ) {
					this.$Notice.error( {
						title: "操作失败",
						desc: resp.msg
					} );
					return
				}else{
					this.$Notice.success( {
						title: "修改成功",
						desc: resp.msg
					} );
					this.selectPageData();
				}
			},
			async adddate(){
				let validResult = false;
				this.$refs.modalDataModalForm.validate( valid => {
					validResult = valid
				} );
				if ( !validResult ) {
					this.$refs.modalDataModal.buttonLoading = false;
					return;
				}
				this.modalData.display = false
				let params = {url:'/api/couponCard'}
						params['beginTimestamp']   = Moment( this.modalData.data.createDate[0] )?Moment( this.modalData.data.createDate[0] ).format( 'YYYY-MM-DD 00:00:00' ):"";
						params['endTimestamp']     = Moment( this.modalData.data.createDate[1] )?Moment( this.modalData.data.createDate[1] ).format( 'YYYY-MM-DD 23:59:59' ):"";
						params['cardId']           = this.modalData.data['cardId'];
						params['couponCardSource'] = this.modalData.data['couponCardSource'];
						params['couponCardType']   = this.modalData.data['couponCardType'];
						params['description']      = this.modalData.data['description'];
						params['leastCost']        = this.modalData.data['leastCost'] * 100;
						params['totalQuantity']    = this.modalData.data['totalQuantity'];
						params['roomCondition']	   = this.modalData.data['roomCondition'];
						params['userCondition']	   = this.modalData.data['userCondition'];
						params['bearParty']        = this.modalData.data['bearParty'];
						params['showBlueClient']   = this.modalData.data['showBlueClient'];
						params['title']            = this.modalData.data['title'];
						params['remark']           = this.modalData.data['remark'];
						params['maxCost']          = this.modalData.data['maxCost'] * 100;
						params['type']             = 'DATE_TYPE_FIX_TIME_RANGE';
						params['otherUse'] = [this.modalData.data['weekend']?"weekend":"",this.modalData.data['holidays']?"holidays":""].join(',')

				switch (this.modalData.data['couponCardType']) {
				case 1:
					params['exchangeNumber'] = this.modalData.data['exchangeNumber'];
					params['exchangeType']   = 'room';
					break;
				case 2:
					params['reduceCost'] = this.modalData.data['reduceCost'] * 100;
					break;
				case 3:
					params['discount'] = this.modalData.data['discount'];
					break;
				}
				let resp = ( await API.omsAPI[this.env].marketing.CouponCard("POST",params,this.token) ).data;
				if ( resp.retCode ) {
					this.$Notice.error( {
						title: "操作失败",
						desc: resp.msg
					} );
					return
				}
				this.$Notice.success( {
					title: "添加成功",
				});
				this.selectPageData();
			},
			closeModal(v){
				if(!v) this.modalData.display = false
			},
			async deleteData(cardId) {
				this.modalData.delete = false;
				let resp = ( await API.omsAPI[this.env].marketing.CouponCard("delete", {url:'/api/couponCard',cardId} , this.token)).data ;
				if ( resp.retCode ) {
					this.$Notice.error( {
						title: "删除失败",
						desc: resp.msg
					} );
					return
				}
				this.$Notice.success({ title: "删除成功" });
				this.selectPageData();
			},
			initPrice(val = 0) {
				return (val / 100).toFixed(0);
			},
			// 阻止form回车提交事件
			preventSubmit() {
				return false;
			},
			changeDate( dateRange, formName,data, datePicker ) {
				if ( !dateRange[0] ) {
					this[formName][data][datePicker] = [];
				} else {
					let tranferDate = []
						tranferDate.push( Moment( dateRange[0] ).format( 'YYYY-MM-DD 00:00:00' ) );
						tranferDate.push( Moment( dateRange[1] ).format( 'YYYY-MM-DD 23:59:59' ) );
					this[formName][data][datePicker] = tranferDate;
				}
			}
		}
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/marketing/coupon-card-list.vue